export default "__VITE_ASSET__DmE6s8$o__"